/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from "react";
import { useNotification } from "../../context/notification-provider";
import { useDialogs } from "../dialog/use-dialog";
import { IgnoreList } from "./types";
import { deleteIgnoreList } from "./service";

const IgnoreListDelete = ({
  selectedIgnoreList,
  entityType,
  open,
  onClose,
}: {
  selectedIgnoreList: IgnoreList;
  entityType: string;
  open: boolean;
  onClose: () => void;
}) => {
  const { showNotification } = useNotification();
  const { confirm } = useDialogs();

  const hasOpenedRef = React.useRef(false);

  const selectedIgnoreListStr = Object.keys(selectedIgnoreList)
    .map((key) => {
      if (key !== "id" && key !== "entityType") {
        return (selectedIgnoreList as any)[key];
      }
      return null;
    })
    .filter(Boolean)
    .join(", ");

  React.useEffect(() => {
    if (!open || hasOpenedRef.current) return;

    hasOpenedRef.current = true;

    const run = async () => {
      try {
        const result = await confirm(
          <div>
            Are you sure you want to delete <b>{selectedIgnoreListStr}</b>? This
            action cannot be undone.
          </div>,
          {
            title: "Confirm Ignore List Deletion",
            okText: "Delete",
            cancelText: "Cancel",
            severity: "error",
          },
        );

        if (result === true) {
          try {
            await deleteIgnoreList(selectedIgnoreList, entityType);
            showNotification({
              message: "Ignore list value deleted successfully.",
              severity: "success",
              duration: 3000,
            });
          } catch (err) {
            showNotification({
              message: `Failed to delete ignore list value. Reason: ${(err as Error).message}`,
              severity: "error",
              duration: 3000,
            });
          }
        }
      } catch {
        showNotification({
          message: "Failed to show confirmation dialog.",
          severity: "error",
          duration: 3000,
        });
      } finally {
        onClose();
        hasOpenedRef.current = false;
      }
    };

    run();
  }, [
    open,
    confirm,
    showNotification,
    onClose,
    selectedIgnoreList,
    entityType,
    selectedIgnoreListStr,
  ]);

  return null;
};

export default IgnoreListDelete;
